import { render, staticRenderFns } from "./ObjectRightSidebar.vue?vue&type=template&id=188f9fb2&scoped=true"
import script from "./ObjectRightSidebar.vue?vue&type=script&lang=js"
export * from "./ObjectRightSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188f9fb2",
  null
  
)

export default component.exports